module.exports = __webpack_public_path__ + "images/close@2x.png?5146dab2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close@2x.png
// module id = 610
// module chunks = 7